import { filename } from "./filename"

export const downloadVideo = async (cachedBlob, videoUrl) => {
  try {
    const anchor = document.createElement("a")
    anchor.style.display = "none"
    anchor.download = filename()

    let objectUrl = null

    if (cachedBlob) {
      objectUrl = window.URL.createObjectURL(cachedBlob)
      anchor.href = objectUrl
    } else if (videoUrl) anchor.href = videoUrl
    else throw new Error("No video source available for download")

    document.body.appendChild(anchor)
    anchor.click()

    document.body.removeChild(anchor)
    if (objectUrl) window.URL.revokeObjectURL(objectUrl)
  } catch (error) {
    console.error("Error downloading video:", error)
  }
}
